type AnyFunction = (...arguments_: unknown[]) => unknown;

// Utility type to strip methods (functions) from class type
type ClassToPlain<T> = {
  [K in keyof T as T[K] extends AnyFunction ? never : K]: T[K];
};

// Deep cleaner that removes undefined recursively
function deepCleanUndefined<T>(input: T): ClassToPlain<T> {
  if (Array.isArray(input)) {
    return input.map((item) => deepCleanUndefined(item)) as unknown as ClassToPlain<T>;
  }
  if (input && typeof input === 'object') {
    const cleaned: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(input)) {
      if (value !== undefined) {
        cleaned[key] = deepCleanUndefined(value);
      }
    }
    return cleaned as ClassToPlain<T>;
  }
  return input as ClassToPlain<T>;
}

// toPojo function that:
// - Uses structuredClone (deep clone, no prototypes/methods)
// - Types output as pure POJO (no methods)
export function toPojo<T>(input: T): ClassToPlain<T> {
  const cleaned = deepCleanUndefined(input);
  return structuredClone(cleaned) as ClassToPlain<T>;
}
